export const ActionTypes = {
  LOAD_TOP_ARTIST_REQUEST: "@HOME/LOAD_TOP_ARTIST_REQUEST",
  LOAD_TOP_ARTIST_SUCCESS: "@HOME/LOAD_TOP_ARTIST_SUCCESS",
  LOAD_TOP_ARTIST_FAILURE: "@HOME/LOAD_TOP_ARTIST_FAILURE",

  LOAD_PRINCIPAL_EVENTS_REQUEST: "@HOME/LOAD_PRINCIPAL_EVENTS_REQUEST",
  LOAD_PRINCIPAL_EVENTS_SUCCESS: "@HOME/LOAD_PRINCIPAL_EVENTS_SUCCESS",
  LOAD_PRINCIPAL_EVENTS_FAILURE: "@HOME/LOAD_PRINCIPAL_EVENTS_FAILURE",

  LOAD_SEARCH_EVENTS_REQUEST: "@SEARCH/LOAD_SEARCH_EVENTS_REQUEST",
  LOAD_SEARCH_EVENTS_SUCCESS: "@SEARCH/LOAD_SEARCH_EVENTS_SUCCESS",
  LOAD_SEARCH_EVENTS_FAILURE: "@SEARCH/LOAD_SEARCH_EVENTS_FAILURE",

  LOGIN_REQUEST: "@HOME/LOGIN_REQUEST",
  LOGIN_SUCCESS: "@HOME/LOGIN_SUCCESS",
  LOGIN_FAILURE: "@HOME/LOGIN_FAILURE",
  LOGIN_LOGOUT:  "@HOME/LOGIN_LOGOUT",
};
